export const cars = {
  // Search
  searchCars: 'Rechercher',
  searchCarsDescription: 'Trouvez la voiture parfaite pour votre voyage',
  location: 'Lieu',
  selectLocation: 'Sélectionner un lieu',
  checkInDate: 'Date de Prise en Charge',
  checkOutDate: 'Date de Retour',
  selectDate: 'Sélectionner une date',
  searchNow: 'Rechercher Maintenant',
  clearAll: 'Tout Effacer',
  optionalDates: 'Optionnel: Ajoutez des dates pour de meilleurs résultats',
  checkIn: 'Prise en charge',
  checkOut: 'Retour',
  whereGoing: 'Où allez-vous?',
  whenTrip: 'Quand est votre voyage?',
  quickSelect: 'Sélection rapide',
  threeDays: '3 jours',
  oneWeek: '1 semaine',
  twoWeeks: '2 semaines',
  search: 'Rechercher',
  
  // Cars page
  availableCars: 'Voitures Disponibles',
  carsCount: '{{count}} voiture disponible',
  carsCount_other: '{{count}} voitures disponibles',
  noCarsAvailable: 'Aucune voiture disponible pour le moment.',
  imageNotAvailable: 'Image non disponible',
  seats: 'places',
  automatic: 'Auto',
  manual: 'Manuelle',
  others: 'autres',
  perDay: '/jour',
  book: 'Réserver',
  available: 'Disponible',
  currency: 'MAD',
  notAvailable: 'N/D',
  insured: 'Assuré',
  
  // Error handling
  error: 'Erreur',
  retry: 'Réessayer',
  loadingCars: 'Chargement des voitures...',
  
  // Car listing page
  findPerfectCar: 'Trouvez la voiture parfaite pour votre prochain voyage',
  searchByMakeModel: 'Rechercher par marque ou modèle',
  allCategories: 'Toutes les Catégories',
  allTransmissions: 'Toutes les Transmissions',
  anySeats: 'Toutes les Places',
  clearFilters: 'Effacer les Filtres',
  carsFound: 'voitures trouvées',
  noCarsFound: 'Aucune voiture trouvée',
  adjustSearchCriteria: 'Essayez d\'ajuster vos critères de recherche ou effacez les filtres pour voir plus de résultats.',
  more: 'plus',
  filters: 'Filtres',
  category: 'Catégorie',
  transmission: 'Transmission',
  priceRange: 'Gamme de Prix (MAD)',
  minPrice: 'Min',
  maxPrice: 'Max',
  filtered: 'Résultats filtrés',
  
  // Enhanced filters
  allBrands: 'Toutes les marques',
  searchBrands: 'Rechercher des marques...',
  noBrandsFound: 'Aucune marque trouvée.',
  allModels: 'Tous les modèles',
  selectBrandFirst: 'Sélectionner une marque',
  
  // Car details
  viewDetails: 'Voir Détails',
  specifications: 'Spécifications',
  featuresTab: 'Caractéristiques',
  moreFeatures: 'plus de caractéristiques',
  noFeatures: 'Aucune caractéristique disponible',
  description: 'Description',
  gallery: 'Galerie',
  
  // Booking
  selectCar: 'Sélectionner la Voiture',
  bookNow: 'Réserver Maintenant',
  reserveNow: 'Réserver Maintenant',
  pricePerDay: 'par jour',
  
  // Reviews
  reviews: 'Avis',
  writeReview: 'Écrire un Avis',
  rating: 'Note',
  
  // Car Details Page
  rentalAgency: 'Agence de Location',
  bookThisCar: 'Réserver Cette Voiture',
  locationDetails: 'Lieux de prise en charge et retour',
  dateTimeDetails: 'Dates et horaires',
  additionalDetails: 'Informations supplémentaires',
  pickupLocation: 'Lieu de prise en charge',
  dropoffLocation: 'Lieu de retour',
  pickupTime: 'Heure de prise en charge',
  returnTime: 'Heure de retour',
  day: 'jour',
  days: 'jours',
  additionalNotes: 'Notes Supplémentaires',
  additionalNotesPlaceholder: 'Entrez des notes supplémentaires...',
  dailyRate: 'Tarif Journalier',
  duration: 'Durée',
  total: 'Total',
  processing: 'Traitement...',
  needToSignIn: 'Vous devez vous connecter',
  toBookThisCar: 'pour réserver cette voiture',
  fuel: 'Carburant',
  pricingSummary: 'Résumé des Prix',
  taxesIncluded: 'Taxes incluses',
  instantConfirmation: '✓ Confirmation instantanée',
  freeCancellation: '✓ Annulation gratuite jusqu\'à 24h',
  invalidDateRange: 'La date de retour doit être après la date de prise en charge',
  
  // Agency Details
  agencyDetails: {
    title: 'Détails de l\'Agence',
    description: 'La page de détails de l\'agence pour l\'ID: {{id}} est en cours de développement.',
  },
  
  // Agency filtering
  filterByAgency: 'Filtrer par Agence',
  browsingAgencyCars: 'Parcourir les voitures de {{agency}}',
  agencyNotFound: 'Agence non trouvée',
  
  // Booking features
  features: {
    cancelAnytime: 'Annulation gratuite',
    instantConfirmation: 'Confirmation instantanée',
    flexibleTiming: 'Horaires flexibles 8h-22h',
    premiumSupport: 'Support client premium 24/7',
    multipleLocations: 'Récupération dans plusieurs villes'
  },

  // Search Panel
  pickupDropoff: 'Prise en charge / Retour',
  searchLocation: 'Rechercher un lieu...',
  noLocationFound: 'Aucun lieu trouvé.',
  agency: 'Agence',
  dates: 'Dates',
  pickDate: 'Choisir une date',
  notesPlaceholder: 'Demandes spéciales ou notes...',
  changeLocation: 'Changer le lieu',
  totalPrice: 'Prix Total',
  selectPickupLocation: 'Sélectionner le lieu de prise en charge',
  selectDropoffLocation: 'Sélectionner le lieu de retour',
  select: 'Sélectionner',
  openInMap: 'Ouvrir dans la carte',
  bookingSuccess: 'Réservation Réussie !',
  bookingCreatedSuccessfully: 'Votre réservation a été créée avec succès !',
  agencyWillContact: 'L\'agence va vous contacter sur WhatsApp pour confirmer votre réservation.',
  keepPhoneAvailable: 'Merci de garder votre téléphone disponible.',
  trackInDashboard: 'Vous pouvez suivre votre réservation dans votre tableau de bord',
  goToDashboard: 'Aller au Tableau de Bord',
  
  // Category browsing
  browseByCategory: 'Parcourir par Catégorie',
  browsingCategoryDescription: 'Découvrez notre sélection de',
  
  // Availability status
  availabilityStatus: 'Disponibilité',
  allStatuses: 'Tous les Statuts',
  availableStatus: 'Disponible',
  rented: 'Louée',
  maintenance: 'Maintenance',
  unavailable: 'Non Disponible',
  showAll: 'Afficher Tout',
  availableOnly: 'Disponibles Seulement',
  availableOnlySelectedDates: 'Disponibles Seulement aux Dates Sélectionnées',
  availableOnlyToday: 'Disponibles Seulement Aujourd\'hui',
  applyFilters: 'Appliquer les Filtres',
  nameAZ: 'Nom: A-Z',
  
  // Sort options
  sortBy: 'Trier par',
  relevant: 'Pertinent',
  newest: 'Plus récent',
  priceLowHigh: 'Prix: Croissant',
  priceHighLow: 'Prix: Décroissant',
  yearNewest: 'Année: Récente',
  
  // Related cars
  otherCarsSameCategory: 'Autres Voitures dans la Même Catégorie',
  otherCarsSameCity: 'Autres Voitures dans la Même Ville',
  loadingRelatedCars: 'Chargement des voitures similaires...',
  noRelatedCars: 'Aucune voiture similaire trouvée'
}; 